import * as actionTypes from "./actionTypes";

export function getCartItems(payload) {
    return {
        type: actionTypes.GET_CART_ITEMS,
        payload,
    };
}

export function getCartItemsSuccess(data) {
    return {
        type: actionTypes.GET_CART_ITEMS_SUCCESS,
        ...data,
    };
}

export function getCartItemsFailure(errors) {
    return {
        type: actionTypes.GET_CART_ITEMS_FAILURE,
        errors,
    };
}

export function getActiveShoppingCart(payload) {
    return {
        type: actionTypes.GET_ACTIVE_SHOPPING_CART,
        payload,
    };
}

export function getActiveShoppingCartSuccess(data) {
    return {
        type: actionTypes.GET_ACTIVE_SHOPPING_CART_SUCCESS,
        ...data,
    };
}

export function getActiveShoppingCartFailure(errors) {
    return {
        type: actionTypes.GET_ACTIVE_SHOPPING_CART_FAILURE,
        errors,
    };
}

export function createShoppingCart(payload) {
    return {
        type: actionTypes.CREATE_SHOPPING_CART,
        payload,
    };
}

export function createShoppingCartSuccess(data) {
    return {
        type: actionTypes.CREATE_SHOPPING_CART_SUCCESS,
        ...data,
    };
}

export function createShoppingCartFailure(errors) {
    return {
        type: actionTypes.CREATE_SHOPPING_CART_FAILURE,
        errors,
    };
}

export function addCartItem(payload) {
    return {
        type: actionTypes.ADD_CART_ITEM,
        payload,
    };
}

export function addCartItemSuccess(data) {
    return {
        type: actionTypes.ADD_CART_ITEM_SUCCESS,
        ...data,
    };
}

export function addCartItemFailure(errors) {
    return {
        type: actionTypes.ADD_CART_ITEM_FAILURE,
        errors,
    };
}

export function deleteCartItem(payload) {
    return {
        type: actionTypes.DELETE_CART_ITEM,
        payload,
    };
}

export function deleteCartItemSuccess(data) {
    return {
        type: actionTypes.DELETE_CART_ITEM_SUCCESS,
        ...data,
    };
}

export function deleteCartItemFailure(errors) {
    return {
        type: actionTypes.DELETE_CART_ITEM_FAILURE,
        errors,
    };
}

export function updateActiveAction(data) {
    return {
        type: actionTypes.UPDATE_ACTIVE_ACTION,
        data,
    };
}

export function beginTransaction(payload) {
    return {
        type: actionTypes.BEGIN_TRANSACTION,
        payload,
    };
}

export function beginTransactionSuccess(data) {
    return {
        type: actionTypes.BEGIN_TRANSACTION_SUCCESS,
        ...data,
    };
}

export function beginTransactionFailure(errors) {
    return {
        type: actionTypes.BEGIN_TRANSACTION_FAILURE,
        errors,
    };
}

export function reviewWarrantyData(warrantyId) {
    return {
        type: actionTypes.REVIEW_WARRANTY_DATA,
        warrantyId,
    };
}

export function reviewWarrantyDataSuccess(data) {
    return {
        type: actionTypes.REVIEW_WARRANTY_DATA_SUCCESS,
        ...data,
    };
}

export function resetReviewWarrantyData() {
    return {
        type: actionTypes.RESET_REVIEW_WARRANTY_DATA,
    };
}

export function clearSuccessMsg() {
    return {
        type: actionTypes.CLEAR_MSG,
    };
}

export function reSubmitCart(payload) {
    return {
        type: actionTypes.RE_SUBMIT_CART,
        payload,
    };
}

export function reSubmitCartSuccess(data) {
    return {
        type: actionTypes.RE_SUBMIT_CART_SUCCESS,
        ...data,
    };
}

export function reSubmitCartFailure(errors) {
    return {
        type: actionTypes.RE_SUBMIT_CART_FAILURE,
        errors,
    };
}

export function resetShoppingCartDetails() {
    return {
        type: actionTypes.RESET_SHOPPING_CART_DETAILS,
    }
}